import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import AnimateFadeInUp from "./AnimateFadeInUp";
import BackToTop from "../app/BackToTop";

const MultiToken = () => {
  const isMobile = window.innerWidth <= 768; // Change the breakpoint as needed
  const tokenData = [
    {
      svg: (
        <svg
          width="68"
          height="68"
          viewBox="0 0 68 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="68" height="68" rx="34" fill="white"></rect>
          <path
            d="M32.2244 12V18.4443C32.2244 20.0593 31.5827 21.6082 30.441 22.7499L26.8451 26.3467C26.3541 26.8395 25.9212 27.3887 25.5607 27.9776C24.762 29.3017 24.3423 30.8294 24.3423 32.3969C24.3423 34.6828 25.2292 36.8259 26.8451 38.4365L33.6887 45.2836C34.8083 46.4041 35.4369 47.9231 35.4369 49.5072V56L22.3588 42.9246C19.6021 40.1697 18.0568 36.5023 18.0012 32.6005C17.9483 28.6026 19.6251 24.602 22.6021 21.6259L32.2244 12Z"
            fill="url(#paint0_linear_1_35)"
          ></path>
          <path
            d="M49.2336 32.1661C49.2821 35.457 48.285 38.5901 46.3464 41.2225C46.2794 41.3124 46.2116 41.4023 46.1401 41.4922C45.7611 41.9832 45.3317 42.4637 44.8725 42.9265L44.3514 43.4475C44.3514 43.4475 44.3462 43.4511 44.3435 43.4546L41.7394 46.0587L37.2601 41.5795L40.3914 38.4402C40.8287 38.0056 41.2333 37.5031 41.593 36.946C41.6212 36.9028 41.6494 36.8578 41.6776 36.8128C42.4746 35.4984 42.896 33.9724 42.896 32.3988C42.896 30.1129 42.0074 27.9663 40.3914 26.3486L36.8017 22.7615C35.6583 21.619 35.0156 20.0692 35.0156 18.4533V12.0134L44.6424 21.6402C47.5445 24.5423 49.1745 28.281 49.2327 32.1661H49.2336Z"
            fill="url(#paint1_linear_1_35)"
          ></path>
          <path
            d="M46.1392 41.4904C45.7602 41.9814 45.3308 42.4619 44.8715 42.9247L44.3505 43.4457C44.3505 43.4457 44.3452 43.4492 44.3426 43.4528L41.7384 46.0569L32.5313 36.8498C31.4382 35.7567 30.8237 34.273 30.8237 32.7267V26.1758L46.1401 41.4922L46.1392 41.4904Z"
            fill="url(#paint2_linear_1_35)"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_1_35"
              x1="53.167"
              y1="13.5657"
              x2="22.6224"
              y2="45.4987"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white"></stop>
              <stop offset="1"></stop>
            </linearGradient>
            <linearGradient
              id="paint1_linear_1_35"
              x1="43.1798"
              y1="50.9074"
              x2="41.9668"
              y2="21.4877"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white"></stop>
              <stop offset="1"></stop>
            </linearGradient>
            <linearGradient
              id="paint2_linear_1_35"
              x1="23.6821"
              y1="14.9746"
              x2="40.3015"
              y2="40.7931"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white"></stop>
              <stop offset="1"></stop>
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "ELYS",
      description:
        "The network utility token with 200M max supply. Non-inflationary rewards paid in USDC.",
    },
    {
      svg: (
        <svg
          width="69"
          height="68"
          viewBox="0 0 69 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="68.0851" height="68" rx="34" fill="white"></rect>
          <g clipPath="url(#clip0_1_46)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.8317 14.3301C36.9494 14.41 39.2017 14.8299 41.3194 15.6723C43.8621 16.6718 46.695 18.3849 49.1056 21.2006C51.7804 24.3075 53.079 27.5714 53.6078 30.7066C53.6622 31.1007 53.8981 32.5485 53.8981 33.208V34.8928C53.7918 36.3406 53.6078 37.8425 53.1827 39.316C52.3895 42.1059 50.9847 45.0814 48.2295 47.8713C45.4483 50.6896 42.4831 52.1632 39.6242 53.0056C38.8829 53.2168 38.0354 53.4255 37.2682 53.5311C36.685 53.6109 35.5989 53.7938 34.8836 53.7938H33.1884C29.666 53.6109 26.0114 52.5831 22.5174 50.1332C22.6755 49.7648 22.914 49.3423 23.2846 48.9739C23.4427 48.7884 24.5029 47.7889 24.7672 47.7889C24.8476 47.7889 25.747 48.3943 26.2239 48.6313C28.37 49.7622 30.568 50.3676 32.7374 50.5273C32.8437 50.5273 33.0822 50.5788 33.1599 50.5788H34.9069C36.151 50.4475 37.3433 50.3161 38.5875 49.9477C41.0239 49.2367 43.6443 47.9718 46.0548 45.473C48.0947 43.3399 49.2585 41.1013 49.922 38.9425C50.0801 38.3886 50.2408 37.8115 50.3471 37.2834C50.4793 36.5209 50.5856 35.7043 50.6659 34.9417V33.1513C50.5856 32.0462 50.4015 30.8611 50.0827 29.7276C49.4995 27.6204 48.5198 25.4899 46.7469 23.4084C44.8936 21.1697 42.7216 19.776 40.7362 18.9053C40.153 18.6683 39.5439 18.4313 38.9607 18.2484C38.4034 18.0629 37.8228 17.9599 37.2915 17.8259C37.0012 17.7718 35.1998 17.5374 34.9095 17.5374H33.1625C32.0247 17.5889 30.8324 17.7744 29.6945 18.0913C27.6287 18.6451 25.537 19.5931 23.4972 21.2779C21.2733 23.0683 19.8166 25.2014 18.9146 27.1747C18.7565 27.4916 18.5958 27.8857 18.4636 28.2541C18.1733 28.9909 17.9349 29.7276 17.8027 30.4644C17.6964 30.9899 17.432 32.4661 17.432 33.1771V34.916C17.5383 36.7862 17.9349 38.6024 18.7306 40.4701C20.1613 34.545 27.7609 31.2295 31.4156 30.3588C32.3435 30.1218 33.3232 29.859 34.2745 29.622C37.504 28.8054 41.6097 27.3318 44.0461 23.2512C44.3105 22.7772 44.6033 22.3032 44.8392 21.8292C44.6267 22.7515 44.3364 23.751 43.9113 24.7248C43.5407 25.5414 43.1182 26.4894 42.6672 27.3576C42.4546 27.7801 42.1643 28.2 41.9259 28.6225C39.5957 32.5717 35.3061 34.9932 32.048 36.0984C30.5395 36.6239 29.0284 36.7296 27.5199 37.0207C28.2871 37.2577 29.1087 37.3375 29.8759 37.3375L30.9075 37.3118C34.8006 36.9176 38.9037 35.5729 42.6127 31.2553C42.6931 32.0178 42.903 32.8602 42.903 33.6511C42.903 39.6277 36.9986 42.8144 32.416 43.5769C31.965 43.6284 31.5685 43.8397 31.146 43.9195C28.6292 44.342 26.0891 45.1046 23.5983 46.8692C23.5464 46.895 23.492 46.9748 23.4116 47.0264C21.504 48.3428 20.5527 50.213 20.3661 51.818C18.9613 49.9477 18.7254 47.9203 18.2744 46.1041C18.1681 45.6559 17.7197 45.3416 17.4813 44.9706C16.924 44.1282 16.4497 43.2858 16.0505 42.4434C15.8639 42.0209 15.654 41.5469 15.4933 41.1528C15.1485 40.2589 14.8323 39.231 14.6457 38.3628C14.5394 37.809 14.1947 35.7815 14.1947 34.9134V33.2028C14.1947 32.0977 14.4072 30.9642 14.6198 29.8848C15.4129 25.8042 18.1681 20.7498 23.1473 17.5374C23.6501 17.2205 24.1789 16.9062 24.7102 16.6151C25.3712 16.2467 26.0865 15.9299 26.776 15.6671C28.8677 14.8505 31.1201 14.4022 33.2377 14.325H34.8265L34.8317 14.3301Z"
              fill="black"
            ></path>
          </g>
          <defs>
            <clipPath id="clip0_1_46">
              <rect
                width="39.7163"
                height="39.6312"
                fill="white"
                transform="translate(14.1844 14.1843)"
              ></rect>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "EDEN",
      description:
        "The vesting inflationary reward token used for bootstrapping liquidity and  redeemable for ELYS.",
    },
    {
      svg: (
        <svg
          width="69"
          height="69"
          viewBox="0 0 69 69"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="68.0851"
            height="68.0851"
            rx="34.0426"
            fill="white"
          ></rect>
          <path
            d="M40.1447 47.5175L31.7072 34.5813L21.7254 20.5671H27.8652L36.1519 32.7333L46.3598 47.5175H40.1447Z"
            fill="url(#paint0_linear_1_54)"
          ></path>
          <path
            d="M40.1447 47.5175L31.7072 34.5813L21.7254 20.5671H27.8652L36.1519 32.7333L46.3598 47.5175H40.1447Z"
            fill="url(#paint1_linear_1_54)"
          ></path>
          <path
            d="M21.7254 47.5175L31.9332 32.7718L40.22 20.5671H46.3598L36.3779 34.5813L27.9405 47.5175H21.7254Z"
            fill="black"
          ></path>
          <path
            d="M21.7254 47.5175L31.9332 32.7718L40.22 20.5671H46.3598L36.3779 34.5813L27.9405 47.5175H21.7254Z"
            fill="url(#paint2_linear_1_54)"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_1_54"
              x1="25.0001"
              y1="22.0007"
              x2="43.0001"
              y2="48.0007"
              gradientUnits="userSpaceOnUse"
            >
              <stop></stop>
              <stop offset="0.255208" stopColor="#383838"></stop>
              <stop offset="0.458137" stopColor="#6A6A6A"></stop>
              <stop offset="0.665395" stopColor="#404040"></stop>
              <stop offset="1"></stop>
            </linearGradient>
            <linearGradient
              id="paint1_linear_1_54"
              x1="35.8692"
              y1="51.3557"
              x2="35.4299"
              y2="28.0356"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white"></stop>
              <stop offset="1"></stop>
            </linearGradient>
            <linearGradient
              id="paint2_linear_1_54"
              x1="35.8692"
              y1="51.3557"
              x2="35.4299"
              y2="28.0356"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white"></stop>
              <stop offset="1"></stop>
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "EDEN-Boost",
      description:
        "The multiplier token that rewards long-term participation in Elys.",
    },
  ];

  const [activeTokenIndex, setActiveTokenIndex] = useState(0);
  const [hoveredTokenIndex, setHoveredTokenIndex] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (hoveredTokenIndex === null) {
        setActiveTokenIndex((prevIndex) => (prevIndex + 1) % tokenData.length);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [tokenData.length, hoveredTokenIndex]);
  return (
    <section className="multi-token-model position-relative">
      <div className="text-center text-white">
        <AnimateFadeInUp>
          <h2>Multi-Token Model to Power Network Rewards</h2>
        </AnimateFadeInUp>
      </div>
      <div className="container">
        {/* <Row>
          {tokenData.map((token, index) => (
            <Col md={4} className="mb-4 mb-md-0" key={index}>
              <AnimateFadeInUp afterFadeClass={"remove-fade-css"}>
                <div
                  className={`multi-token-box ${
                    (activeTokenIndex === index || hoveredTokenIndex === index) ? 'active' : ''
                  }`}
                  onMouseEnter={() => {
                    setHoveredTokenIndex(index);
                    setActiveTokenIndex(index); // Set active token to the hovered token
                  }}
                  onMouseLeave={() => {
                    setHoveredTokenIndex(null);
                    setActiveTokenIndex((prevIndex) => (prevIndex + 1) % tokenData.length); // Resume interval-based toggling
                  }}
                >
                  <h4>{token.svg}{token.title}</h4>
                  <p>{token.description}</p>
                </div>
              </AnimateFadeInUp>
            </Col>
          ))}
        </Row> */}
        <Row>
          {tokenData.map((token, index) => (
            <Col md={4} className="mb-4 mb-md-0" key={index}>
              <AnimateFadeInUp afterFadeClass={"remove-fade-css"}>
                <div
                  className={`multi-token-box ${
                    activeTokenIndex === index || hoveredTokenIndex === index
                      ? "active"
                      : ""
                  }`}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      setHoveredTokenIndex(index);
                      setActiveTokenIndex(index); // Set active token to the hovered token
                    }
                  }}
                  onMouseLeave={() => {
                    if (!isMobile) {
                      setHoveredTokenIndex(null);
                      setActiveTokenIndex(
                        (prevIndex) => (prevIndex + 1) % tokenData.length
                      ); // Resume interval-based toggling
                    }
                  }}
                >
                  <h4>
                    {token.svg}
                    {token.title}
                  </h4>
                  <p>{token.description}</p>
                </div>
              </AnimateFadeInUp>
            </Col>
          ))}
        </Row>
      </div>

      {/* Add your content and styling for the MultiToken component here */}
      <BackToTop></BackToTop>
    </section>
  );
};

export default MultiToken;
